import Vue from 'vue'
import Router from 'vue-router'

// 页面引入
import pageIndex from '@/pages/index/index'	 //首页
import pageList from '@/pages/list/index'	 //列表页
import pageDetail from '@/pages/detail/index'	 //详情页

Vue.use(Router)

export default new Router({
	//mode:'history',
	// 解决路由跳转后，不显示在首行
	scrollBehavior() {
		return {x: 0, y: 0};
	},
	routes: [
		{ path: '/index', name: 'pageIndex', component:pageIndex ,meta: {  pageName: pageIndex } },
		{ path: '/list/:catid', name: 'pageList', component:pageList ,meta: {  pageName: pageList } },
		{ path: '/detail/:id', name: 'pageDetail', component:pageDetail ,meta: {  pageName: pageDetail } },
		{ path: '*', name: 'pageIndex', component:pageIndex, redirect: '/index' },
	]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
 return originalPush.call(this, location).catch(err => err);
}


// WEBPACK FOOTER //
// ./src/router/index.js